
import { computed, defineComponent, onMounted } from "vue";

import {
  ColumnDefinition,
  CountButton,
  BaseButton,
  EditIcon,
  DeleteIcon,
  BaseTable,
} from "@tager/admin-ui";
import { Page } from "@tager/admin-layout";
import { useResource, useResourceDelete } from "@tager/admin-services";

import { deleteProductGroup, getProductGroupList } from "@/services/requests";
import { ProductGroupType } from "@/typings/model";
import { getProductListUrl, getProductGroupFormUrl } from "@/utils/paths";

const COLUMN_DEFS: Array<ColumnDefinition<ProductGroupType>> = [
  {
    id: 1,
    name: "ID",
    field: "id",
    style: { width: "50px", textAlign: "center" },
    headStyle: { width: "50px", textAlign: "center" },
  },
  {
    id: 2,
    name: "Название",
    field: "name",
  },
  {
    id: 3,
    name: "Системное имя",
    field: "systemName",
  },
  {
    id: 4,
    name: "",
    field: "other",
    style: { width: "146px", whiteSpace: "nowrap" },
    headStyle: { width: "146px" },
  },
  {
    id: 5,
    name: "Действия",
    field: "actions",
    style: { width: "101px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "101px", textAlign: "center" },
  },
];

export default defineComponent({
  name: "ProductGroupList",
  components: {
    Page,
    CountButton,
    BaseButton,
    EditIcon,
    DeleteIcon,
    BaseTable,
  },
  setup() {
    const [
      fetchProductGroupList,
      { data: productGroupList, loading: isProductGroupListLoading, error },
    ] = useResource<Array<ProductGroupType>>({
      fetchResource: getProductGroupList,
      initialValue: [],
      resourceName: "Product group list",
    });

    onMounted(() => {
      fetchProductGroupList();
    });

    const { handleResourceDelete: handleProductGroupDelete, isDeleting } =
      useResourceDelete({
        deleteResource: deleteProductGroup,
        resourceName: "ProductGroup",
        onSuccess: fetchProductGroupList,
      });

    const isRowDataLoading = computed<boolean>(
      () => isProductGroupListLoading.value
    );

    function isBusy(productGroupId: number): boolean {
      return isDeleting(productGroupId) || isRowDataLoading.value;
    }

    return {
      columnDefs: COLUMN_DEFS,
      rowData: productGroupList,
      isRowDataLoading,
      errorMessage: error,
      isBusy,
      handleProductGroupDelete,
      getProductGroupFormUrl,
      getProductListUrl,
    };
  },
});
